import * as layoutActions from "../../actions/layoutActions";
import * as ajax from "../../actions/ajaxCounterActions";
import * as exception from "../../actions/exceptionActions";

import financieelApi from "../../api/financieelApi";

import { getStore } from "../../store/configureStore";
import * as beads from "../../actions/beadActions";

export default class FinancieelPageHelper {

	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const dossierId = this.context.props.dossierId;
		this.getByDossierId(dossierId);
	}

	loadLayout(financieel) {
		const dossierId = this.context.props.dossierId;

		this.dispatch(layoutActions.loadFinancieelPageLayout(financieel.naam, financieel.tabTitel, dossierId, financieel.typeDossier));
	}

	getByDossierId(dossierId) {
		this.dispatch(ajax.started());
		financieelApi.getByDossier(dossierId)
			.then(response => {
				this.dispatch(ajax.ended());
				this.dispatch(beads.beadsLoaded(response.data.beadModels));
				this.loadLayout(response.data);
			})
			.catch(error => {
				this.dispatch(ajax.failed(error));
				this.dispatch(exception.throwException(error));
			});
	}

	isReadyToRender() {
		return true;
	}
}